import styled from "styled-components";
import { TOP_NAV_HEIGHT } from "../../../../constants";

export const EmptyFileList = styled.div`
  // Center Text within StatusBar
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  padding: 24px 0px;
  width: 700px;
`;

export const StyledFileList = styled.div`
  display: flex;
  flex-direction: column;
  // 80px represents the padding on top and bottom of the Home container combined
  // 168px represents the header banner logo
  // 12px represents the margin at the bottom of the file list
  max-height: calc(100vh - ${TOP_NAV_HEIGHT} - 80px - 168px - 12px);
  // Header plus one row
  min-height: 136px;
  width: 732px;
  overflow: scroll;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }
`;

export const FileListHeader = styled.div`
  // Gives the same padding as the FileListItem
  padding: 22px 36px 10px 28px;
  display: flex;
  color: #2a2a3d;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: -0.13px;
  background: #ffffff;
  width: 700px;
  box-sizing: border-box;

  > div {
    display: flex;
    align-items: flex-end;
  }
`;

export const FileListItem = styled.div`
  display: flex;
  align-items: center;

  svg {
    overflow: visible;
  }
`;

export const FileListItemContent = styled.div`
  width: 636px;
  padding: 22px 36px 22px 28px;
  margin-right: 16px;
  display: flex;
  background: #ffffff;
  color: #191919;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.22px;
  line-height: 36px;
  border-top: 1px solid rgba(155, 155, 194, 0.3);
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

export const Date = styled(Cell)`
  width: 70px;
  min-width: 70px;
  margin-right: 20px;
`;

export const Rows = styled(Cell)`
  width: 75px;
  min-width: 75px;
`;

export const Devices = styled(Cell)`
  width: 40px;
  min-width: 40px;
`;

export const DevicesHeader = styled(Devices)`
  width: 50px;
  min-width: 50px;
  // 25px more margin than Cell because it's 25px less wide than Devices
  margin-right: 35px;
`;

export const Networks = styled(Cell)`
  width: 70px;
  min-width: 70px;
`;

export const NetworksHeader = styled(Networks)`
  width: 50px;
  min-width: 50px;
  // 20px more margin than Cell because it's 20px less wide than Networks
  margin-right: 30px;
`;

export const Airings = styled(Cell)`
  width: 70px;
  min-width: 70px;
`;

export const AiringsHeader = styled(Airings)`
  width: 50px;
  min-width: 50px;
  // 20px more margin than Cell because it's 20px less wide than Airings
  margin-right: 30px;
`;

export const Brands = styled(Cell)`
  width: 70px;
  min-width: 70px;
`;

export const Titles = styled(Cell)`
  width: 40px;
  min-width: 40px;
  margin-right: 30px;
`;

export const TitlesHeader = styled(Cell)`
  width: 40px;
  min-width: 40px;
  margin-right: 30px;
`;

export const BrandsHeader = styled(Airings)`
  width: 50px;
  min-width: 50px;
  // 20px more margin than Cell because it's 20px less wide than Airings
  margin-right: 30px;
`;

export const View = styled(Cell)`
  width: 30px;
  min-width: 30px;
  margin-left: 6px;
  justify-content: center;

  // Last cell in the table, doesn't need margin
  margin-right: 0px;

  svg {
    cursor: pointer;
    width: 30px;
    height: 20px;
  }
`;

export const Country = styled(Cell)`
  width: 20px;
  min-width: 20px;
`;

export const PbseVersion = styled(Cell)`
  width: 40px;
  min-width: 40px;
`;
